import * as React from "react"
import { Link } from "gatsby"

import Container from "../container/container"

import * as styles from "./intro.module.scss"

import flowers from "../../assets/home/intro-links-bg.svg"
import arrow from "../../assets/home/arrow-right.svg"

import Markdown from "react-markdown"

const HomeIntro = props => {
  return (
    <div>
      <div className={styles.intro}>
        <Container>
          <div
            className={`${styles.intro__wrap} d-flex align-items-center justify-content-between`}
          >
            <div className={styles.intro__content}>
              <h2>{props.data.IntroHeading}</h2>
              <Markdown>{props.data.IntroBody}</Markdown>
            </div>
            <div
              className={`${styles.intro__boxes} d-flex align-items-center justify-content-between`}
            >
              {props.data.Cards.map((card, key) => (
                <div
                  className={styles.intro__boxes__box}
                  key={key}
                  style={{
                    backgroundImage: `url('${card.BackgroundImage.publicURL}')`,
                  }}
                >
                  <div className={styles.intro__boxes__box__overlay}></div>
                  <div className={styles.intro__boxes__box__content}>
                    <img src={card.Image.publicURL} alt={card.Text} />
                    <p>{card.Text}</p>
                    <a target="_blank" href={card.ButtonLink} className="cta">
                      {card.ButtonText}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </div>
      <div className={styles.intro__links}>
        <img
          src={flowers}
          alt="Flowers BG"
          className={styles.intro__links__bg}
        />
        <Container>
          <div className={styles.intro__links__content}>
            <Markdown>{props.data.SecondIntroBody}</Markdown>
            {props.data.Buttons.map((button, key) => (
              <a target="_blank" href={button.ButtonLink} key={key}>
                <span>{button.ButtonText}</span>
                <img src={arrow} alt="Arrow Link" />
              </a>
            ))}
          </div>
        </Container>
      </div>
    </div>
  )
}

export default HomeIntro
